export default "__VITE_ASSET__Yj02VJTf__"